import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeLayoutGroup as removeLayoutGroupFromLayout
} from '../redux/layouts'

export default function * requestRemoveLayoutGroup (action) {
  const { layoutId, id } = action.payload

  const state = yield select()

  const layout = state['view-home'].layouts.byId[layoutId]
  const currentIndex = layout && layout.layoutGroups.indexOf(id)

  let optimisticAction
  if (currentIndex !== -1) {
    optimisticAction = yield optimisticPut(removeLayoutGroupFromLayout({
      layoutId,
      layoutGroupId: id
    }))
  }

  try {
    yield call(apiAction, 'RemoveLayoutGroup', {
      layoutId,
      groupId: id
    })

    if (currentIndex !== -1) {
      yield optimisticAction.commit()
    }
  } catch (error) {
    if (currentIndex !== -1) {
      yield optimisticAction.revert()
    }

    throw error
  }
}
